/**
 * Module definition houses collection of stack namespaced modules
 * that are included at the root of each application route.
 *
 * @module stack
 */
angular.module('stack', [
  'stack.common',
  'stack.plugins',
  'stack.templates',
  'stack.contenttemplates'
]);
